import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { Map } from 'immutable';
import { withStyles } from '@material-ui/core/styles';
const styles = {
  flex: {
    flex: 1
  },
  white: {
    color: 'white'
  },
  toolbar: {
    minHeight: '100%'
  },
  appBar: {
    boxShadow: 'none',
    backgroundColor: '#334058',
    zIndex: 0
  }
};
const TitleBar = props => {
  const classes = props.classes,
    children = props.children,
    open = props.open,
    onClick = props.onClick,
    collapsible = props.collapsible;
  const renderTitle = () => {
    if (props.children) {
      return /*#__PURE__*/React.createElement(Typography, {
        className: "".concat(classes.flex, " ").concat(classes.white),
        "data-testid": "DefiForm-TitleBar-title"
      }, children);
    }
  };
  const renderCollapseIcon = () => {
    if (collapsible) {
      return /*#__PURE__*/React.createElement(IconButton, {
        className: classes.white,
        "data-testid": "DefiForm-TitleBar-collapse"
      }, open ? /*#__PURE__*/React.createElement(KeyboardArrowUp, {
        "data-testid": "DefiForm-TitleBar-collapse-open"
      }) : /*#__PURE__*/React.createElement(KeyboardArrowDown, {
        "data-testid": "DefiForm-TitleBar-collapse-closed"
      }));
    }
  };
  return /*#__PURE__*/React.createElement(AppBar, {
    position: "static",
    style: children ? {
      height: 36
    } : {
      height: 5
    },
    className: classes.appBar,
    onClick: () => onClick(),
    "data-testid": "DefiForm-TitleBar"
  }, /*#__PURE__*/React.createElement(Toolbar, {
    className: classes.toolbar
  }, renderTitle(), renderCollapseIcon()));
};
export default withStyles(styles)(TitleBar);